import React from "react";
import "./ScheduleCardCompact.css";

interface ScheduleCardCompactProps {
  icon: string;
  name: string;
  onClick?: () => void;
}

const ScheduleCardCompact: React.FC<ScheduleCardCompactProps> = ({ icon, name, onClick }) => (
  <div className="schedule-card-compact" onClick={onClick}>
    <span className="schedule-icon">{icon}</span>
    <span className="schedule-name">{name}</span>
  </div>
);

export default ScheduleCardCompact; 